'use strict';

var GetText = require('node-gettext');
require('@nextcloud/router');
require('dompurify');
require('escape-html');

/**
 * Returns the user's language
 */
function getLanguage() {
    return document.documentElement.lang || 'en';
}

/**
 * This module provides functionality to translate applications independent from Nextcloud
 *
 * @packageDocumentation
 * @module @nextcloud/l10n/gettext
 * @example
 * ```js
import { getGettextBuilder } from '@nextcloud/l10n/gettext'
const gt = getGettextBuilder()
            .detectLocale() // or use setLanguage()
            .addTranslation(/* ... *\/)
            .build()
gt.gettext('some string to translate')
```
 */
/**
 * @notExported
 */
class GettextBuilder {
    constructor() {
        this.translations = {};
        this.debug = false;
    }
    setLanguage(language) {
        this.locale = language;
        return this;
    }
    /** Try to detect locale from context with `en` as fallback value */
    detectLocale() {
        return this.setLanguage(getLanguage().replace('-', '_'));
    }
    addTranslation(language, data) {
        this.translations[language] = data;
        return this;
    }
    enableDebugMode() {
        this.debug = true;
        return this;
    }
    build() {
        return new GettextWrapper(this.locale || 'en', this.translations, this.debug);
    }
}
/**
 * @notExported
 */
class GettextWrapper {
    constructor(locale, data, debug) {
        this.gt = new GetText({
            debug,
            sourceLocale: 'en',
        });
        for (const key in data) {
            this.gt.addTranslations(key, 'messages', data[key]);
        }
        this.gt.setLocale(locale);
    }
    subtitudePlaceholders(translated, vars) {
        return translated.replace(/{([^{}]*)}/g, (a, b) => {
            const r = vars[b];
            if (typeof r === 'string' || typeof r === 'number') {
                return r.toString();
            }
            else {
                return a;
            }
        });
    }
    /**
     * Get translated string (singular form), optionally with placeholders
     *
     * @param original original string to translate
     * @param placeholders map of placeholder key to value
     */
    gettext(original, placeholders = {}) {
        return this.subtitudePlaceholders(this.gt.gettext(original), placeholders);
    }
    /**
     * Get translated string with plural forms
     *
     * @param singular Singular text form
     * @param plural Plural text form to be used if `count` requires it
     * @param count The number to insert into the text
     * @param placeholders optional map of placeholder key to value
     */
    ngettext(singular, plural, count, placeholders = {}) {
        return this.subtitudePlaceholders(this.gt.ngettext(singular, plural, count).replace(/%n/g, count.toString()), placeholders);
    }
}
/**
 * Create a new GettextBuilder instance
 */
function getGettextBuilder() {
    return new GettextBuilder();
}

exports.getGettextBuilder = getGettextBuilder;
